<template>
    <div class="film-card">
      <h1>{{ film.title }}</h1>
      <div class="mb-4">
      <p v-if="film.year">Année : <strong>{{ film.year }}</strong></p>
      <p v-if="film.duration">Durée : <strong>{{ film.duration }}</strong></p>
      <p v-if="film.production">Production : <strong>{{ film.production }}</strong></p>
      </div>
      <div class="mb-4 synopsis">
          <h2>Synopsis</h2>
          <p>{{ film.synopsis }}</p>
      </div>
  
      <div class="mb-4">
          <h3>Équipe</h3>
          <ul>
            <li v-for="(member, role) in film.crew" :key="role">
              {{ role }} : <strong>{{ member }}</strong>
            </li>
          </ul>
      </div>
  
      <div class="mb-4">
          <h4 v-if="film.festivals.length > 0">Festivals / Formations en résidence</h4>
          <ul>
            <li v-for="(festival, index) in film.festivals" :key="index">
              {{ festival.name }}
            </li>
          </ul>
      </div>
  
      <div v-if="film.availability">
        <h4>Ressources</h4>
        <a :href="film.availability.link" target="_blank" rel="noopener">{{ film.availability.text }}</a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      film: Object,
    },
  };
  </script>
  
  <style scoped>
  .film-card {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .film-card h1 {
    margin-bottom: 1rem;
    font-size: 2.2em;
    color: #32825e;
  }

  .film-card li{
    font-size: 1.2em;
  }

  .film-card  p{
    font-size: 1.2em;
  }
  .film-card a {
    color: #2c3e50;
    text-decoration: none;
    font-size: 1.2em;
  }
  .film-card a:hover {
    text-decoration: underline;
  }
  </style>